import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { AddProgrammedMessageForm } from '../_components/programmed-message-form.component'
import { ConfigurationHeaderWrapper } from '../../../../_components/configuration-header-wrapper.component'
import { FollowupTimeline } from '../../_components/followup-timeline.component'
import { useSortedFollowupTimeline } from '../../_components/use-sorted-followup-timeline.hook'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'

export default function AddProgrammedMessagePage() {
  const { t } = useTranslation()
  const { followupId } = useParams()
  const defaultFollowupId = Number(followupId)
  const [messageName, setMessageName] = useState<string>(t('pages.configuration.messages.creating-message'))

  const { isLoading, error, timelineMedEventsSorted } = useSortedFollowupTimeline(followupId)

  if (error) return <ErrorQueryHandler error={error} />
  if (isLoading) return <div className="loading" />

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.messages.add-programmed-message')}
      subTitle={t('pages.configuration.messages.explanations')}
      className="c-flex c-flex-row c-pb-10 c-relative"
    >
      <FollowupTimeline timelineMedEventsSorted={timelineMedEventsSorted} itemLabelBeingAdded={messageName} />
      <div className="c-bg-grey-200 c-w-px c-h-full" />
      <div className="c-w-full c-min-w-0 c-pl-4">
        <AddProgrammedMessageForm defaultFollowupId={defaultFollowupId} onNameChange={setMessageName} />
      </div>
    </ConfigurationHeaderWrapper>
  )
}
